import * as CSS from "csstype"
import { system } from "styled-system"

const gridColumnEnd = system({
  gridColumnEnd: true,
})

export interface GridColumnEndProps {
  gridColumnEnd?: CSS.Property.GridColumnEnd | CSS.Property.GridColumnEnd[]
}

export default gridColumnEnd
